/** Import react/libraries section **/
import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';

/** Import resources section **/
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

/** Import component section **/
import ModalTitle from './ModalTitle';
import ModalActions from './ModalActions';

const ModalComponent = (props) => {
  const {
    open,
    title,
    width = 600,
    children,
    onClose,
    onConfirm,
    closeText = 'Cancel',
    confirmText = 'Ok',
    disabled
  } = props;

  const useStyles = makeStyles((theme) => ({
    paper: {
      width: width + 'px'
    }
  }));

  const classes = useStyles();
  let refWrapper = createRef();

  return (
    <div ref={refWrapper}>
      <Dialog
        open={open}
        onClose={onClose}
        fullWidth={true}
        maxWidth={'md'}
        classes={{ paper: classes.paper }}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
            onConfirm();
          }}
          noValidate
        >
          <ModalTitle onClose={onClose}>{title}</ModalTitle>

          <DialogContent>{children}</DialogContent>

          <ModalActions
            onClose={onClose}
            onConfirm={onConfirm}
            cancelText={closeText}
            confirmText={confirmText}
            disabled={disabled}
          />
        </form>
      </Dialog>
    </div>
  );
};

ModalComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  width: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  disabled: PropTypes.bool
};

export default ModalComponent;
